export const DEFAULT_ALLOW_DISCOUNT_COMBINATION = true;
export const DEFAULT_HAS_PERCENTAGE_OFF_DISCOUNT = false;
